import { render, staticRenderFns } from "./AddBookmakerModal.vue?vue&type=template&id=c4a4bc9a&scoped=true&"
import script from "./AddBookmakerModal.vue?vue&type=script&lang=js&"
export * from "./AddBookmakerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a4bc9a",
  null
  
)

export default component.exports